import actions from './actions';

const initState = {
    devices: [],
    errors: {},
    loading: false,
    versions: [],
    firmwareVersions: [],
    launcherVersions: [],
    installerVersions: [],
    isFetchingVersions: false,
    isFetchingFirmwareVersions: false,
    isUpdating: false,
    isCanceling: false,
    updateSuccess: false,
    confirmLoading: false,
    isDeleting: false,
    loadingFetchIds: false,
    deviceIds: [],
    exitKioskPin: [],
};

function sortVersions(arr) {
    arr.sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        if (dateB !== dateA) return dateB - dateA;
        const numA = parseFloat(a.number.replace(/[^0-9.]+/g, ""));
        const numB = parseFloat(b.number.replace(/[^0-9.]+/g, ""));
        return numB - numA;
    });
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_SUPPORT_DEVICES:
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_SUPPORT_DEVICES_SUCCESS:
            return {
                ...state,
                devices: action.devices,
                loading: false,
            };
        case actions.FETCH_SUPPORT_DEVICES_ERROR:
            return {
                ...state,
                devices: [],
                loading: false,
            };
        case actions.FETCH_SUPPORT_DEVICE_LOG:
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_SUPPORT_DEVICE_LOG_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case actions.FETCH_SUPPORT_DEVICE_LOG_ERROR:
            return {
                ...state,
                loading: false,
            };
        case actions.REQUEST_SUPPORT_DEVICE_UPDATE:
            return {
                ...state,
                isUpdating: true,
            };
        case actions.REQUEST_SUPPORT_DEVICE_UPDATE_SUCCESS:
            return {
                ...state,
                isUpdating: false,
            };
        case actions.REQUEST_SUPPORT_DEVICE_UPDATE_ERROR:
            return {
                ...state,
                isUpdating: false,
            };
        case actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE:
            return {
                ...state,
                isDeleting: true
            };
        case actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_SUCCESS:
            return {
                ...state,
                isDeleting: false,
            };
        case actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_ERROR:
            return {
                ...state,
                isDeleting: false,
            };
        case actions.REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE: 
            return {
                ...state,
                isUpdating: true,
            };
        case actions.REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_SUCCESS:
            return {
                ...state,
                isUpdating: false,
            };
        case actions.REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_ERROR:
            return {
                ...state,
                isUpdating: false,
            }
        case actions.REQUEST_SUPPORT_DEVICE_CANCEL:
            return {
                ...state,
                isCanceling: true,
            };
        case actions.REQUEST_SUPPORT_DEVICE_CANCEL_SUCCESS:
            return {
                ...state,
                isCanceling: false,
            };
        case actions.REQUEST_SUPPORT_DEVICE_CANCEL_ERROR:
            return {
                ...state,
                isCanceling: false,
            };
        case actions.FETCH_SUPPORT_DEVICE_VERSIONS:
            return {
                ...state,
                isFetchingVersions: true,
            };
        case actions.FETCH_SUPPORT_DEVICE_FIRMWARE_VERSIONS:
            return {
                ...state,
                isFetchingFirmwareVersions: true
            }
        case actions.FETCH_SUPPORT_DEVICE_VERSIONS_SUCCESS:
            const versionsSorted = action.versions
            sortVersions(versionsSorted)
            return {
                ...state,
                versions: action.versions,
                isFetchingVersions: false,
            };
        case actions.FETCH_SUPPORT_DEVICE_FIRMWARE_VERSION_SUCCESS:
            sortVersions(action.firmwareVersions)
            sortVersions(action.installerVersions)
            sortVersions(action.launcherVersions)
            return {
                ...state,
                firmwareVersions: action.firmwareVersions,
                launcherVersions: action.launcherVersions,
                installerVersions: action.installerVersions,
                isFetchingFirmwareVersions: false
            }
        case actions.FETCH_SUPPORT_DEVICE_VERSIONS_ERROR:
            return {
                ...state,
                versions: [],
                isFetchingVersions: false,
            };
        case actions.REQUEST_SUPPORT_LOG:
            return {
                ...state,
                confirmLoading: true,
            };
        case actions.REQUEST_SUPPORT_LOG_SUCCESS:
            return {
                ...state,
                confirmLoading: false,
            };
        case actions.REQUEST_SUPPORT_LOG_ERROR:
            return {
                ...state,
                confirmLoading: false,
            };
        case actions.FETCH_SUPPORT_DEVICES_UPDATED:
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_SUPPORT_DEVICES_UPDATED_SUCCESS:
            return {
                ...state,
                devices: action.devices,
                loading: false,
            };
        case actions.FETCH_SUPPORT_DEVICES_UPDATED_ERROR:
            return {
                ...state,
                devices: [],
                loading: false,
            };
        case actions.FETCH_EXIT_KIOSK_PIN:
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_EXIT_KIOSK_PIN_SUCCESS:
            return {
                ...state,
                exitKioskPin: action.devices,
                loading: false,
            };
        case actions.FETCH_EXIT_KIOSK_PIN_ERROR:
            return {
                ...state,
                exitKioskPin: [],
                loading: false,
            };
        default:
            return state;
    }
}
